export const GENDER_OPTIONS = [
  {
    label: 'Male',
    value: 0,
  },
  {
    label: 'Female',
    value: 1,
  },
  {
    label: 'Other',
    value: 2,
  },
];
